<template>
    <div>
        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'需求管理'},{title:'转化需求'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>需求信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine weekplandetail19">
                                        <el-form :model="zy" label-position="right" ref="zy" :rules="rules"
                                                 :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="客户类型" class="h-elformWrap-2" prop="euType">
                                                <brselect category="userCareType" v-model="zy.euType" :v="zy.euType" :disabled="true"></brselect>
                                            </el-form-item>
                                            <el-form-item label="客户全称" class="h-elformWrap-2" prop="euName">
                                                <el-input v-model="zy.euName" :v="zy.euName" :disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
                                                <brselect category="YLRegion" v-model="zy.areaCode" :v="zy.areaCode"></brselect>
                                            </el-form-item>
                                            <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                                                <el-input v-model="zy.contactuserName" :v="zy.contactuserName" placeholder="请输入"></el-input>
                                            </el-form-item>
                                            <el-form-item label="部门科室" class="h-elformWrap-2" prop="department">
                                                <el-input v-model="zy.department" :v="zy.department" placeholder="请输入"></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                                                <el-input v-model="zy.telephone" :v="zy.telephone" placeholder="请输入"></el-input>
                                            </el-form-item>
                                            <el-form-item label="需求类型" class="h-elformWrap-2">
                                                <el-input value="资源需求" :disabled="true"></el-input>
                                            </el-form-item>
                                            <el-form-item label="答复截止时间" class="h-elformWrap-2" prop="endDate">
                                                <el-date-picker type="datetime" value-format="yyyy-MM-dd HH"
                                                                placeholder="选择时间"
                                                                style="width: 3.1rem"
                                                                :clearable="false" :picker-options="pickerOptions"
                                                                v-model="zy.endDate">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="痛点" class="h-elformWrap-1" prop="pain">
                                                <el-input v-model="zy.pain" maxlength="250"
                                                          placeholder="请输入"></el-input>
                                            </el-form-item>
                                            <el-form-item label="需求说明" class="h-elformWrap-1" prop="content">
                                                <el-input v-model="zy.content" maxlength="250"
                                                          placeholder="请输入"></el-input>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                    <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
                                        <div class="h-pieceTitle2 message">
                                            <h1 class="h1">资源需求部门</h1>
                                        </div>
                                        <el-table
                                                ref="multipleTable"
                                                :data="deptList"
                                                stripe
												border
                                                style="width: 100%">
                                            <el-table-column
                                                    type="index"
                                                    label="#"
                                                    width="40">
                                            </el-table-column>
                                            <el-table-column
                                                    prop="jobGroup"
                                                    label="链群"
                                                    width="300">
                                                <template scope="scope">
                                                    <el-select v-model="scope.row.jobGroup" :v="scope.row.jobGroup"
                                                               placeholder="请选择" style="width: 100%"
                                                               @change="selectUser(scope.row)">
                                                        <el-option v-for="(item) in JobGroup"
                                                                   :key="item.id"
                                                                   :label="item.jobGroup"
                                                                   :value="item.jobGroup"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="jobGroupPoint"
                                                    label="链群节点"
                                                    width="250">
                                                <template scope="scope">
                                                    <el-select v-model="scope.row.jobGroupPoint" :v="scope.row.jobGroupPoint"
                                                               placeholder="请选择" style="width: 100%"
                                                               @change="selectUser(scope.row)">
                                                        <el-option value="创单" label="创单"></el-option>
                                                        <el-option value="体验" label="体验"></el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column
                                                    prop="pointUser"
                                                    label="部门及回复人"
                                                    min-width="400">
                                                <template scope="scope">
                                                    <el-select v-model="scope.row.pointUser" :v="scope.row.pointUser"
                                                               placeholder="请选择" style="width: 100%"
                                                               @change="getNameCode(scope.row)">
                                                        <el-option v-for="(item) in PointUser"
                                                                   :key="item.id"
                                                                   :label="item.pointUser"
                                                                   :value="item.pointUser"
                                                        >
                                                        </el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="操作" fixed="right" width="100">
                                                <template slot-scope="scope">
                                                   <el-button
                                                            type="text"
                                                            class="h-tableLink h-btn"
                                                            @click="deleteThis(scope.$index)">
                                                        删除
                                                    </el-button>
													<!-- <div class="l-operationBox">
														<span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.$index)"></span>
													</div> -->
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                        <div class="h-tableAdd" style="background-color: rgb(94, 182, 233);">
                                            <a @click="add">新增一行</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-txtCenter h-mrt60">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="backL">返回</el-button>
            <!-- <el-button class="h-btn h-bBtn h-bggreen" @click="zanCun">暂存</el-button>-->
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="savezy">确认提交</el-button>
        </div>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'

    export default {
        data() {
            return {
                cid:null,
                ag:{},
                j:{
                    jobGroup: null,
                    jobGroupPoint: null,
                },
                //部门及回复人
                PointUser: [],
                //链群
                JobGroup: [],
                //资源需求回复部门列表
                deptList: [],
                f: {
                    userName: null,
                },
                checkflagchilds: false,
                checki: null,
                acList: [],
                //带线表单
                value: false,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                zy: {
                    cid: null,
                    userName: null,
                    euName: null,
                    euCode: null,
                    demandType: null,
                    demandType: 3,
                    contactuserName: null,
                    department: null,
                    telephone: null,
                    endDate: null,
                    deptList: [],
                    areaCode: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                },
                customer:{
                    areaCode:null,
                },
                rules: {
                    areaCode: [{required: true, message: '请选择区域', trigger: 'change'}],
                    department: [{required: true, message: '请填写部门/科室', trigger: 'change'}],
                    contactuserName: [{required: true, message: '请填写联系人', trigger: 'change'}],
                    telephone: [{required: true, message: '请填写联系电话', trigger: 'change'}],
                    pain: [{required: true, message: '请填写痛点', trigger: 'blur'}],
                    content: [{required: true, message: '请填写需求说明', trigger: 'blur'}],
                    endDate: [{required: true, message: '请选择答复截止时间', trigger: 'blur'}],
                }
            }
        },
        created() {
            this.query();
            this.selectJobGroup();
        },
        methods: {
            //带出用户编码
            getNameCode(value) {
                this.PointUser.forEach(elements => {
                    if (value.pointUser == elements.pointUser) {
                        value.jobPoint = elements.jobPoint;
                        value.jobUsername = elements.jobUsername;
                        value.jobUsercode = elements.jobUsercode;
                    }
                })
            },
            //用户名列表
            selectUser(value) {
                value.pointUser = null;
                this.j.jobGroup = value.jobGroup;
                this.j.jobGroupPoint = value.jobGroupPoint;
                ss.UserDemand.selectUser(this.j).then(rd => {
                    this.PointUser = rd;
                });
            },
            //部门列表
            selectJobGroup() {
                ss.UserDemand.selectJobGroup().then(rd => {
                    this.JobGroup = rd;
                });
            },
            //删除该行项目产品信息
            deleteThis(index) {
                this.deptList.splice(index, 1);
            },
            add() {
                var list = {
                    jobGroup: null,
                    jobGroupPoint: null,
                    pointUser: null,
                    jobPoint:null,
                    jobUsername:null,
                    jobUsercode:null
                }
                this.deptList.push(list);
            },
            query() {
                this.zy.cid = this.$route.query.id;
                this.cid = this.zy.cid;
                ss.UserDemand.showUserCare(this.zy.cid).then(rd => {
                    this.zy = rd.obj;
                    this.zy.contactuserName = rd.obj.contact;
                    this.zy.department= rd.obj.contactDept;
                    this.zy.telephone= rd.obj.contactPhone;
                })
            },
            savezy() {
                var subflag = false;
                this.$refs['zy'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善需求信息后再提交！");
                        return false;
                    }
                });
                if (subflag) {
                    if (this.deptList.length != 0) {
                        var depflag = true;
                        this.deptList.forEach(e => {
                            if (e.jobGroup == null || e.jobGroupPoint == null || e.pointUser == null) {
                                depflag = false;
                                this.$msg.msge("请完善资源需求部门信息再提交！");
                                return false;
                            }
                        });
                        if (depflag) {
                            this.zy.demandType = 3;
                            this.zy.id = null;
                            this.zy.cid = this.cid;
                            this.zy.deptList = this.deptList;
                            this.$msg.confirm("确认提交该资源需求?", () => {
                                ss.UserDemand.savezy(this.zy).then(rd => {
                                    this.$msg.msgs("操作成功");
                                    this.$router.push("/xuqiu/resourceList");
                                });
                            });
                        }
                    } else {
                        this.$msg.msge("请完善资源需求部门信息再提交！");
                        return false;
                    }
                }
            },
            backL() {
                this.$router.go(-1);
            },
        }
    }
</script>

<style scoped>
    .categoryBox {
        display: flex;
        border-bottom: 1px solid #dcdfe1;
    }

    .categoryBox .category {
        width: 122px;
        height: 37px;
        color: #b0b0b0;
        font-size: 0.2rem;
        text-align: center;
        line-height: 36px;
        margin-left: 20px;
        border: 1px solid #b4b4b4;
        cursor: pointer;
        border-bottom: 0;
    }

    .categoryBox .category:first-child {
        margin-left: 0;
    }

    .categoryBox .category.active {
        color: #fff;
        border: 1px solid #0e75e9;
        background: #0e75e9;
    }

    .checkidBox {
        position: relative;
        overflow: hidden;
        border: 1px solid #ccc;
        padding: 5px 10px;
        margin-left: 20px;
        cursor: pointer;
        border-radius: 5px;
        height: 39px;
        line-height: 39px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .checkidBox:first-child {
        margin-left: 0;
    }

    .checkidBox.active {
        border-color: #0e75e9;
        background: #0e75e9;
        color: #fff;
    }

    .inputlabel {
        position: absolute;
        left: -20px;
        top: 0;
        z-index: 3;
        padding-left: 7px !important;
        font-size: 14px !important;
        margin: 4px 0 0;
    }
</style>
<style>
    .h-formLine .el-checkbox__input {
        display: none;
    }

    .h-formLine .el-checkbox.is-bordered.is-checked {
        background: #2c83fd;
    }

    .h-formLine .el-checkbox-button.is-checked .el-checkbox-button__inner::after {
        content: "";
        background: url(../../assets/images/checkBox.png);
        width: 10px;
        height: 10px;
    }

    .h-formLine .el-checkbox-button__inner {
        border: none;
        padding: 9px 15px;
    }

    .h-formLine .el-checkbox-button:first-child .el-checkbox-button__inner {
        border-radius: 0;
    }

    .h-formLine .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #fff;
    }

    .h-formLine .el-checkbox-button:last-child .el-checkbox-button__inner {
        border-radius: 0;
    }

    .weekplandetail19 .h-formbLine .el-form-item__label {
        width: 31%;
        text-align: right;
    }

    .weekplandetail19 .h-formbLine .el-form-item__content {
        width: 69%;
    }

    .weekplandetail19 .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
        padding-right: 0.5rem
    }

    .weekplandetail19 .h-formbLine .h-elformWrap-1 {
        width: 100%;
        padding-right: 0.5rem
    }

    .weekplandetail19 .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 9.7%;
    }

    .weekplandetail19 .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 90.3%;
    }
</style>
